// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"ActivityDashboard_dashboardContainer__2-dzU","video":"ActivityDashboard_video__3kpN9"};